import React from 'react';
import {useTranslation} from "../hooks/useTranslation";

type DownloadsListLoadMoreProps = {
    loadMore : (event: React.MouseEvent<HTMLElement>) => void
}

function DownloadsListLoadMore({loadMore} : DownloadsListLoadMoreProps) {

    const translate = useTranslation();

    return (
        <div className='downloadsOverview__list--loadmore'>
            <div className='btn btn--variant-outline' onClick={loadMore}>
                <p>{translate('downloads.loadmore')}</p>
            </div>
        </div>
    );
}

export default DownloadsListLoadMore;
